import { Link } from 'react-router-dom';

export default function AboutSection() {
  return (
    <section className="w-full bg-background-50 py-14 md:py-20">
      <div className="w-full max-w-6xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1">
            <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-4">
              What Is Vigorbuy Spreadsheet?
            </span>
            <h2 className="font-heading text-2xl md:text-3xl font-semibold text-foreground-900 mb-5">
              Your Complete Product Research Platform
            </h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
              Vigorbuy Spreadsheet is a structured product database designed to help users discover, organize and research products efficiently. Whether you are a seasoned shopper or just getting started, our spreadsheets make product discovery faster, smarter, and more organized.
            </p>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6">
              Instead of scrolling endlessly through unorganized listings, Vigorbuy Spreadsheet puts every product category into clean, filterable tables so you can compare prices, features, and quality at a glance.
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
              <div className="flex items-start gap-3 p-4 rounded-lg bg-background-100 border border-background-200">
                <div className="w-8 h-8 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 flex-shrink-0">
                  <i className="ri-search-eye-line"></i>
                </div>
                <div>
                  <h4 className="font-medium text-sm text-foreground-900 mb-1">Smart Discovery</h4>
                  <p className="text-xs text-foreground-500">Find products faster with organized categories</p>
                </div>
              </div>
              <div className="flex items-start gap-3 p-4 rounded-lg bg-background-100 border border-background-200">
                <div className="w-8 h-8 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 flex-shrink-0">
                  <i className="ri-bar-chart-grouped-line"></i>
                </div>
                <div>
                  <h4 className="font-medium text-sm text-foreground-900 mb-1">Easy Comparison</h4>
                  <p className="text-xs text-foreground-500">Compare products side by side in structured tables</p>
                </div>
              </div>
              <div className="flex items-start gap-3 p-4 rounded-lg bg-background-100 border border-background-200">
                <div className="w-8 h-8 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 flex-shrink-0">
                  <i className="ri-shield-check-line"></i>
                </div>
                <div>
                  <h4 className="font-medium text-sm text-foreground-900 mb-1">Verified Data</h4>
                  <p className="text-xs text-foreground-500">Trust information that is regularly reviewed</p>
                </div>
              </div>
              <div className="flex items-start gap-3 p-4 rounded-lg bg-background-100 border border-background-200">
                <div className="w-8 h-8 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 flex-shrink-0">
                  <i className="ri-user-heart-line"></i>
                </div>
                <div>
                  <h4 className="font-medium text-sm text-foreground-900 mb-1">Beginner Friendly</h4>
                  <p className="text-xs text-foreground-500">No experience needed to start discovering products</p>
                </div>
              </div>
            </div>

            <div className="mt-8">
              <Link
                to="/article/vigorbuy-spreadsheet-complete-guide"
                className="inline-flex items-center gap-2 px-5 py-2.5 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-book-open-line"></i>
                Read the Complete Guide
              </Link>
            </div>
          </div>

          <div className="flex-1 w-full">
            <div className="relative w-full aspect-[4/3] rounded-lg overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Bright%20airy%20home%20office%20corner%20with%20a%20slim%20silver%20laptop%20open%20showing%20colorful%20product%20data%20grid%20on%20screen%2C%20beside%20it%20a%20ceramic%20mug%20with%20a%20small%20green%20succulent%20and%20a%20notepad%20with%20handwritten%20notes%2C%20warm%20natural%20light%20pouring%20through%20sheer%20curtains%2C%20cream%20walls%2C%20light%20oak%20desk%2C%20cozy%20productive%20atmosphere%2C%20soft%20diffused%20shadows%2C%20neutral%20sand%20and%20cream%20tones%2C%20editorial%20interior%20photography%2C%20high%20detail%2C%20calm%20focused%20energy&width=800&height=600&seq=about-v2&orientation=landscape"
                alt="Vigorbuy Spreadsheet product research workspace"
                className="w-full h-full object-cover object-top rounded-lg"
                title="Vigorbuy Spreadsheet - Product Research Platform"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}